import React from "react";
import { Box, Typography, Button, Tooltip } from "@mui/material";

const EmptyState = ({
  icon = "📦",
  title,
  description,
  actionLabel,
  onAction,
  actionDisabled = false,
  actionDisabledReason,
}) => (
  <Box sx={{ textAlign: "center", py: 8, px: 3 }}>
    <Box sx={{ fontSize: 48, mb: 2 }}>{icon}</Box>
    <Typography variant="h5" fontWeight={700} mb={1}>
      {title}
    </Typography>
    {description && (
      <Typography
        variant="body2"
        color="text.secondary"
        maxWidth={360}
        mx="auto"
        mb={3}
      >
        {description}
      </Typography>
    )}
    {actionLabel && onAction && (
      <Tooltip title={actionDisabled ? actionDisabledReason || "" : ""}>
        <span>
          <Button variant="contained" onClick={onAction} disabled={actionDisabled} sx={{ mt: 1 }}>
            {actionLabel}
          </Button>
        </span>
      </Tooltip>
    )}
  </Box>
);

export default EmptyState;
